'use client'

import { Search } from 'lucide-react'
import React, { useId } from 'react'

import { filterFieldTextClassName } from '@/components/CategoryFilterNav/filterFieldText'
import { cn } from '@/utilities/ui'

type BlogPostsSearchPillProps = {
  className?: string
  label: string
  onChange: (value: string) => void
  placeholder: string
  value: string
}

/**
 * Figma 1558:3923 — 320×44 pill, bg white/70, 1px black/10 border,
 * Outfit SemiBold 16 / leading 14, 16px search icon, padding 4×24.
 */
export function BlogPostsSearchPill({
  className,
  label,
  onChange,
  placeholder,
  value,
}: BlogPostsSearchPillProps) {
  const inputId = useId()

  return (
    <div
      className={cn(
        'relative flex h-11 w-full items-center gap-2 rounded-full border border-black/10 bg-white/70',
        'px-6 lg:w-80 lg:shrink-0',
        'focus-within:ring-2 focus-within:ring-turquoise/50',
        className,
      )}
    >
      <label className="sr-only" htmlFor={inputId}>
        {label}
      </label>
      <input
        className={cn(
          'min-w-0 flex-1 bg-transparent py-0 outline-none',
          filterFieldTextClassName,
          'placeholder:text-black/80',
        )}
        id={inputId}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        type="search"
        value={value}
      />
      <Search
        aria-hidden
        className="pointer-events-none size-4 shrink-0 text-black/80"
        strokeWidth={2.5}
      />
    </div>
  )
}
